import React from 'react';
import classnames from 'classnames';
import s from './ListMenu.scss';
export var ListMenu = function (_a) {
    var items = _a.items, className = _a.className, containerId = _a.containerId, containerRole = _a.containerRole, itemRole = _a.itemRole;
    return (React.createElement("ul", { className: classnames(className, s['list']), id: containerId, role: containerRole }, items.map(function (item) {
        return !item.disabled && (React.createElement("li", { key: item.key, className: classnames(s['item'], item.className), role: itemRole }, item.renderElement(item)));
    })));
};
ListMenu.displayName = 'ListMenu';
export default ListMenu;
//# sourceMappingURL=ListMenu.js.map